import React, { useEffect } from 'react';
import * as am5 from '@amcharts/amcharts5';
import * as am5percent from '@amcharts/amcharts5/percent';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

const PieChart = () => {
  useEffect(() => {
    const root = am5.Root.new('pieChartDiv');
    root.setThemes([am5themes_Animated.new(root)]);

    const chart = root.container.children.push(
      am5percent.PieChart.new(root, { radius: am5.percent(90) })
    );

    const series = chart.series.push(
      am5percent.PieSeries.new(root, { valueField: 'value', categoryField: 'category' })
    );

    series.data.setAll([
      { category: 'A', value: 100 },
      { category: 'B', value: 200 },
      { category: 'C', value: 300 }
    ]);

    return () => root.dispose();
  }, []);

  return <div id="pieChartDiv" style={{ width: '100%', height: '400px' }}></div>;
};

export default PieChart;
